import { Alert, List } from "antd";
import { useTranslation } from "react-i18next";
import type { SeveritiesJobSchema } from "../types";
import { SeveritiesEditValues, SeveritiesJobInformation } from "./SeveritiesJobInformation";
interface SeveritiesJobTableBodyProps {
  rows: SeveritiesJobSchema[];
  isLoading: boolean;
  total: number;
  currentPage: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onDelete: (id: string) => void;
  onEdit: (values: SeveritiesEditValues) => Promise<void>;
}
export const SeveritiesJobTableBody = ({
  rows,
  isLoading,
  total,
  currentPage,
  pageSize,
  onPageChange,
  onDelete,
  onEdit
}: SeveritiesJobTableBodyProps) => {
  const {
    t
  } = useTranslation("tools", {
    keyPrefix: "comprehensive.severities"
  });
  // Other users' runs only list once complete, so an incomplete row is the current user's.
  const isProcessing = rows.some(({
    status
  }) => status !== "completed" && status !== "completed_with_errors");
  return <>
      {isProcessing && <Alert message={<div className="text-sm font-medium text-sky-700">{t("processingAlert.title")}</div>} description={<div className="text-xs text-sky-700">{t("processingAlert.blurb")}</div>} rootClassName="border-none p-4 mb-4" />}
      <List dataSource={rows} loading={isLoading} rowKey="id" size="large" itemLayout="vertical" className="mb-4 min-h-36 overflow-hidden rounded-lg border border-gray-200" locale={{
      emptyText: <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
              <p className="m-0 text-sm font-medium text-gray-700">No runs yet</p>
              <p className="m-0 text-sm text-gray-500">Severities runs you start will appear here.</p>
            </div>
    }} pagination={{
      pageSize,
      total,
      current: currentPage,
      onChange: onPageChange,
      showSizeChanger: false,
      hideOnSinglePage: true,
      className: "mb-4 mr-5 [&_a]:!no-underline"
    }} renderItem={schema => <List.Item className="!flex !items-center border-0 border-b !border-gray-200 !p-4 odd:bg-gray-50 xl:h-[72px]">
            <SeveritiesJobInformation schema={schema} onDelete={() => onDelete(schema.id)} onEdit={onEdit} />
          </List.Item>} data-sentry-element="List" data-sentry-source-file="SeveritiesJobTableBody.tsx" />
    </>;
};